import {
	configureLocalStorage,
	getApplication,
	getBrand,
	getGlobalUaOkta,
	getWidgetOptions,
} from '@ua-okta-ui/lib/okta'
import { UaOktaWidget } from '@ua-okta-ui/lib/ua-okta'
import { Locale } from '@ua-okta-ui/types'
;(async () => {
	globalThis.uaOkta = getGlobalUaOkta()

	configureLocalStorage()

	const application = getApplication()
	const brand = getBrand()
	const locale: Locale = globalThis.uaOkta.locale ?? brand?.locales?.[0] ?? 'en-us'

	const options = await getWidgetOptions({ application, brand, locale })
	const widget = new OktaSignIn(options)
	const uaOktaWidget = new UaOktaWidget({ application, brand, element: '#okta-login-container', locale, widget })

	uaOktaWidget.render()
})()
